"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaAuthenticateSmsApi = void 0;
const getAliveEcoaAuthenticateSms = {
    method: "GET",
    url: "/ecoa/authenticate/alive",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const verifyEcoaAuthenticateCode = {
    method: "POST",
    url: "/ecoa/authenticate/verify",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.ecoaAuthenticateSmsApi = { verifyEcoaAuthenticateCode, getAliveEcoaAuthenticateSms };
//# sourceMappingURL=ecoaAuthenticateCode.js.map